import { render, staticRenderFns } from "./AwaitingApproval.vue?vue&type=template&id=992aba5c&"
import script from "./AwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./AwaitingApproval.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AwaitingApproval.vue"
export default component.exports